import React from "react";
import Template from "../components/Template";
import BreadCrumb from "../components/BreadCrumb";

function Contact() {
  return (
    <Template>
      <BreadCrumb pageName="Contact Us" />

      {/* Contact Us Start */}
      <section className="section-lgx">
        <div className="container">
          <div className="row">
            <div className="col-xl-5">
              <div className="pbmit-heading-subheading animation-style1">
                <h4 className="pbmit-subtitle">
                  <span></span>Get In Touch
                </h4>
                <h2 className="pbmit-title">FIND US HERE.</h2>
              </div>
              <p>
                Have a question? We’re here to help you on your fitness journey.
              </p>
              <p>
                <small>
                  <b>
                    Legal Entity: CoachElite
                    <br />
                    Brand Name: DailyFitZone
                  </b>
                </small>
              </p>
              <div className="row">
                <div className="col-md-6">
                  <div className="pbmit-ihbox pbmit-ihbox-style-5">
                    <div className="pbmit-ihbox-headingicon">
                      <div className="pbmit-ihbox-icon">
                        <div className="pbmit-ihbox-icon-wrapper">
                          <div className="pbmit-icon-wrapper pbmit-icon-type-icon">
                            <i className="fa fa-square" />
                          </div>
                        </div>
                      </div>
                      <div className="pbmit-ihbox-contents">
                        <h2 className="pbmit-element-title"> Address </h2>
                        <div className="pbmit-heading-desc">
                          Hyderabad, Telangana,
                          <br /> India
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="col-md-6">
                  <div className="pbmit-ihbox pbmit-ihbox-style-5">
                    <div className="pbmit-ihbox-headingicon">
                      <div className="pbmit-ihbox-icon">
                        <div className="pbmit-ihbox-icon-wrapper">
                          <div className="pbmit-icon-wrapper pbmit-icon-type-icon">
                            <i className="fa fa-square" />
                          </div>
                        </div>
                      </div>
                      <div className="pbmit-ihbox-contents">
                        <h2 className="pbmit-element-title"> CALL & MAIL </h2>
                        <div className="pbmit-heading-desc">
                          <a href="tel:+91 93813 31969">+91 93813 31969</a>
                          <br />
                          <a href="tel:coaching@dailyfitzone.com">
                            coaching@dailyfitzone.com
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="col-md-6">
                  <div className="pbmit-ihbox pbmit-ihbox-style-5">
                    <div className="pbmit-ihbox-headingicon">
                      <div className="pbmit-ihbox-icon">
                        <div className="pbmit-ihbox-icon-wrapper">
                          <div className="pbmit-icon-wrapper pbmit-icon-type-icon">
                            <i className="fa fa-square" />
                          </div>
                        </div>
                      </div>
                      <div className="pbmit-ihbox-contents">
                        <h2 className="pbmit-element-title"> OPENING HOURS </h2>
                        <div className="pbmit-heading-desc">
                          Mon – Sat: 9.00 – 6.00
                          <br />
                          Sun: 9.00 – 1.00
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="col-md-6">
                  <div className="pbmit-ihbox pbmit-ihbox-style-5">
                    <div className="pbmit-ihbox-headingicon">
                      <div className="pbmit-ihbox-icon">
                        <div className="pbmit-ihbox-icon-wrapper">
                          <div className="pbmit-icon-wrapper pbmit-icon-type-icon">
                            <i className="fa fa-square" />
                          </div>
                        </div>
                      </div>
                      <div className="pbmit-ihbox-contents">
                        <h2 className="pbmit-element-title"> FOLLOW US ON </h2>
                        <ul className="pbmit-social-links">
                          <li className="pbmit-social-li pbmit-social-facebook">
                            <a href="#" target="_blank" rel="noreferrer">
                              <span>
                                <i className="pbmit-base-icon-facebook-f" />
                              </span>
                            </a>
                          </li>
                          <li className="pbmit-social-li pbmit-social-twitter">
                            <a href="#" target="_blank" rel="noreferrer">
                              <span>
                                <i className="pbmit-base-icon-twitter" />
                              </span>
                            </a>
                          </li>
                          <li className="pbmit-social-li pbmit-social-linkedin">
                            <a href="#" target="_blank" rel="noreferrer">
                              <span>
                                <i className="pbmit-base-icon-linkedin-in" />
                              </span>
                            </a>
                          </li>
                          <li className="pbmit-social-li pbmit-social-instagram">
                            <a href="#" target="_blank" rel="noreferrer">
                              <span>
                                <i className="pbmit-base-icon-instagram" />
                              </span>
                            </a>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
                {/* end row columns */}
              </div>
            </div>

            <div className="col-xl-7">
              <form
                className="contact-form"
                method="post"
                id="contact-form"
                action="https://gyim-demo.pbminfotech.com/html-demo/send-dummy.php"
              >
                <h4>LEAVE A MESSAGE</h4>
                <div className="row">
                  <div className="col-md-6">
                    <p>
                      <input
                        type="text"
                        className="form-control"
                        placeholder="Name"
                        name="name"
                        required
                      />
                    </p>
                  </div>

                  <div className="col-md-6">
                    <p>
                      <input
                        type="email"
                        className="form-control"
                        placeholder="Email"
                        name="email"
                        required
                      />
                    </p>
                  </div>

                  <div className="col-md-6">
                    <p>
                      <input
                        type="tel"
                        className="form-control"
                        placeholder="Phone"
                        name="number"
                        required
                      />
                    </p>
                  </div>

                  <div className="col-md-6">
                    <p>
                      <input
                        type="text"
                        className="form-control"
                        placeholder="Subject"
                        name="subject"
                        required
                      />
                    </p>
                  </div>

                  <div className="col-lg-12">
                    <p>
                      <textarea
                        name="message"
                        rows="10"
                        className="form-control"
                        placeholder="How can we help you? Feel free to get in touch!"
                        required
                      />
                    </p>
                  </div>

                  <div className="col-lg-12">
                    <button
                      type="submit"
                      className="pbmit-btn pbmit-btn-white pbmit-submit-btn"
                    >
                      <i className="form-btn-loader fa fa-circle-o-notch fa-spin fa-fw margin-bottom d-none" />
                      <span className="button-text">Send a message</span>
                    </button>
                  </div>

                  <div className="col-md-12 col-lg-12 message-status" />
                </div>
              </form>
            </div>
          </div>
        </div>
      </section>
      {/* Contact Us End */}

      {/* Map Start */}
      <section>
        <div className="container-fluid g-0">
          <iframe
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d243646.905100277!2d78.24323428680984!3d17.412608639151465!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bcb99daeaebd2c7%3A0xae93b78392bafbc2!2sHyderabad%2C%20Telangana!5e0!3m2!1sen!2sin!4v1765514116741!5m2!1sen!2sin"
            title="Disneyland Park, Disneyland Drive, Anaheim, CA, USA"
            aria-label="Disneyland Park, Disneyland Drive, Anaheim, CA, USA"
            style={{ width: "100%", border: 0, minHeight: "300px" }}
            allowFullScreen
          />
        </div>
      </section>
      {/* Map End */}
    </Template>
  );
}

export default Contact;
